import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import test1 from "../../../assets/CampuLifeImages/test1.jpg"
import CampusPlacementCareerDynamicPage from '../../CampusSharedComponent/CampusDynamicPages/CampusPlacementAndCareerDynamicPage/CampusPlacementCareerDynamicPage';
import tnpsc from "../../../assets/CampuLifeImages/tnpsc.jpg"
import tnpscworkshop from "../../../assets/CampuLifeImages/tnpscworkshop.jpg"
const TNPSCexam = () => {
    const data = {
    title:"TNPSC - Competitive Exam Coaching",
    img:tnpsc,
    content:"The primary objectives of a placement cell are to facilitate student recruitment, enhance employability skills, and establish strong industry-institute connections, ultimately aiming for successful placements and career development.",
    workshoptitle:"TNPSC Exam Awareness Seminar on 18/03/2025",
    workshopimg:tnpscworkshop,
    listTitle:"Benefits",
    listContent:["The major activities are in accordance with the vision and mission of the college that is to provide opportunities for the rural students and hence each family in and around Thuckalay, may have graduates and postgraduates.",
"Higher education up to the level of PG courses. is provided from our college to the students of all sections of the community without any discrimination.",
"Employment opportunities are provided through Campus Interviews. ",
"Communal harmony is established through NSS, NCC,YRC, Sports and Value Education, Cultural Programmes, Association Meetings and Extension Activities",
"Through quality education, Skill Training and Awareness building programmes, upliftment of socially and economically suppressed students and their parents is being ensured."
    ],
    testimonialTitle:"Testimonials",
    testimonialContent:[{img:test1,staffName:"Samson",staffProfess:"B.A. English",staffContent:"Through quality education, Skill Training and Awareness building programmes, upliftment of socially and economically suppressed students and their parents is being ensured."},
      {img:test1,staffName:"Samson",staffProfess:"B.A. English",staffContent:"Through quality education, Skill Training and Awareness building programmes, upliftment of socially and economically suppressed students and their parents is being ensured."},
      {img:test1,staffName:"Samson",staffProfess:"B.A. English",staffContent:"Through quality education, Skill Training and Awareness building programmes, upliftment of socially and economically suppressed students and their parents is being ensured."}
    ]
  }
    
  return (
    <>
   
    <CampusPlacementCareerDynamicPage data ={data} />
    </>
  )
}

export default TNPSCexam